import React from "react";
import ProfileComponent from "../Components/Profile";

const OrderHistory = () => {
  return <ProfileComponent name={"Order History"} />;
};

export default OrderHistory;
